
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreamPlaybackData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StreamPlayback"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productShortName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distributionTypeName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"streamDelayTypeName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"streamProtocolName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bitrate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isOriginStream"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isManifest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avPlayerParams"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bufferTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"useSuggestedPresentationDelay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trackLiveEdge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableCmaf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"swf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"useDefaults"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"useDashDefaults"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":398}};
    doc.loc.source = {"body":"fragment StreamPlaybackData on StreamPlayback {\n    id\n    url\n    productShortName\n    distributionTypeName\n    streamDelayTypeName\n    streamProtocolName\n    bitrate\n    isOriginStream\n    isManifest\n    avPlayerParams {\n        type\n        bufferTime\n        useSuggestedPresentationDelay\n        trackLiveEdge\n        enableCmaf\n        swf\n        useDefaults\n        useDashDefaults\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["StreamPlaybackData"] = oneQuery(doc, "StreamPlaybackData");
        
